/**
 * VOTE
 */

import Config from '../Config';
import Util from '../Util';

class Vote {
  private articleId: string;

  private voteSelector: string;

  private voteTxtSelector: string;

  constructor(guid: string, data: any) {
    this.articleId = Util.getParams().articleId;
    this.voteSelector = `.board-view .co-btn-like`;
    this.voteTxtSelector = `${this.voteSelector} em`;

    if (Config.isUuid) {
      let _userContentReactionWrapper =
        data && data.voteContents && data.voteContents.userContentReactionWrapper ? data.voteContents.userContentReactionWrapper.userContentReaction : '';
      if (!!_userContentReactionWrapper && !!_userContentReactionWrapper.id && _userContentReactionWrapper.cancelled === false) {
        jQuery(this.voteSelector).addClass('is-active');
      }
    } else {
      if (data.voteContents && data.voteContents.user && data.voteContents.user.loginUser && data.voteContents.user.loginUser.uid === guid) {
        jQuery(this.voteSelector).addClass('is-active');
      }
    }

    this.addEvent();
  }

  private addEvent() {
    jQuery('body').on('click', this.voteSelector, evt => {
      evt.preventDefault();
      this.vote();
      jQuery(this.voteSelector).prop("disabled", true);
      setTimeout( () => {
        jQuery(this.voteSelector).prop("disabled", false);
      }, 1000);
    });
  }

  private setChangeUI(data: any) {
    if (data !== -1) {
      jQuery(this.voteTxtSelector).text(data);
    }
  }

  private vote() {
    const votePromise = Util.get(
      Config.vote({
        board: Config.board,
        articleId: this.articleId
      }),
      'POST'
    );
    votePromise.then(
      (data: any) => {
        if (data !== -1) {
          jQuery(this.voteSelector).addClass('is-active');
          this.setChangeUI(data);
        } else if (data === -1) {
          this.voteCancel();
        }
      },
      (data: any) => {
        Config.apiError(data);
      }
    );
  }

  private voteCancel() {
    const voteCancelPromise = Util.get(
      Config.vote({
        board: Config.board,
        articleId: this.articleId
      }),
      'DELETE'
    );
    voteCancelPromise.then(
      (data: any) => {
        if (data !== -1) {
          jQuery(this.voteSelector).removeClass('is-active');
          this.setChangeUI(data);
        } else if (data === -1) {
          this.vote();
        }
      },
      (data: any) => {
        Config.apiError(data);
      }
    );
  }
}

export default Vote;
